





















































import store from '../../store'
import { touchScreen } from '../../mixins/mixins'

export default {
  mixins: [touchScreen],
  data (this:any) {
    return {
      title: 'Feed',
      isTouchScreen: this.detect(),
      unsetLivestock: false,
      valid: false
    }
  },

  created: function (this:any) {
    // Return true if calculations exist for chosen enterprise
    this.valid = (
      (
        store.state.pasture != null &&
        store.state.pasture.simulation.enterprise === 'Cattle & Sheep' &&
        store.state.cattle != null &&
        store.state.cattle.calculations != null &&
        store.state.sheep != null &&
        store.state.sheep.calculations != null
      ) ||
      (
        store.state.pasture != null &&
        store.state.pasture.simulation.enterprise === 'Sheep' &&
        store.state.sheep != null &&
        store.state.sheep.calculations != null
      ) ||
      (
        store.state.pasture != null &&
        store.state.pasture.simulation.enterprise === 'Cattle' &&
        store.state.cattle != null &&
        store.state.cattle.calculations != null
      )
    )

    // If the pasture is not set, call redirect dialog
    if (store.state.pasture === null) {
      this.unsetLivestock = true
    }
  },

  store
}
